import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-service-category';
const API_DETAIL = (id: number) => `/p-crm-service-category/${id}`;

export interface PCrmServiceCategory {
  id: number;
  psc_descr?: string;
}

export const usePCrmServiceCategorys = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<PCrmServiceCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    pCrmServiceCategorys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePCrmServiceCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<PCrmServiceCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    pCrmServiceCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};
